import { Flex, styled } from '@shared/components';
import type { PropsWithChildren } from '@shared/utils';

export interface RichTextEditorToolbarProps extends PropsWithChildren {
  sticky?: boolean;
}

const ToolbarWrapper = styled(Flex, {
  shouldForwardProp: (props) => props !== 'sticky',
})<RichTextEditorToolbarProps>(({ theme, sticky }) => ({
  alignItems: 'center',
  flexWrap: 'wrap',
  padding: theme.spacing(3, 4),
  gap: theme.spacing(3),
  backgroundColor: theme.palette.background.paper,
  borderBottom: `1px solid ${theme.palette.grey['300']}`,
  borderTopLeftRadius: theme.shape.rounded(2),
  borderTopRightRadius: theme.shape.rounded(2),
  position: sticky ? 'sticky' : 'static',
  zIndex: 1,
  top: 0,
}));

export default function RichTextEditorToolbar(props: Readonly<RichTextEditorToolbarProps>) {
  const { children, sticky: isSticky = true } = props;

  return <ToolbarWrapper sticky={isSticky}>{children}</ToolbarWrapper>;
}
